export const ProductPrice = {
    id: '',
    productId: '',
    productCode: '',
    productName: '',
    brandName: '',
    price: 0
}